import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { QcMerchantResponse } from 'src/app/shared/models/qcResponse.model';

export const MerchantAttributes = createAction('[Merchant: Other]: Merchant Attributes');

export const MerchantAttributesSuccess = createAction(
  '[Merchant: Other]: Merchant Attributes Success',
  props<{ res: { [key: string]: string[] } }>(),
);

export const MerchantAttributesFailed = createAction(
  '[Merchant: Other]: Merchant Attributes Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const PanelStateChanged = createAction('[Merchant: Other]: Panel State Changed');

export const LoadAttributes = createAction(
  '[Merchant: Other]: Load Attributes',
  props<{ res: QcMerchantResponse }>(),
);

export const SaveAttribute = createAction('[Merchant: Other]: Save Attribute');

export const SaveValidAttribute = createAction('[Merchant: Other]: Save Valid Attribute');

export const MerchantAddAttribute = createAction('[Merchant: Other]: Merchant Add Attribute');

export const CancelAttributeAddition = createAction('[Merchant: Other]: Cancel Attribute Addition');

export const DeleteAttributeRow = createAction(
  '[Merchant: Other]: Delete Attribute Row',
  props<{ id: string }>(),
);

export const SelectedCodeChanged = createAction(
  '[Merchant: Other]: Selected Code Changed',
  props<{ selectedCode: string }>(),
);

export const SelectedTypeChanged = createAction(
  '[Merchant: Other]: Selected Type Changed',
  props<{ selectedType: string }>(),
);

export const SelectedValueChanged = createAction(
  '[Merchant: Other]: Selected Value Changed',
  props<{ selectedValue: string }>(),
);

export const NewAttributeDateChanged = createAction(
  '[Merchant: Other]: New Attribute Date Changed',
  props<{ attributeDate: Date; attributeDateText: string }>(),
);

export const ClearAttributeDateValue = createAction(
  '[Merchant: Other]: Clear Attribute Date Value',
);

export const AttributeBoolValueChanged = createAction(
  '[Merchant: Other]: Attribute Boolean Value Changed',
);

export const UpdateMerchantAttributes = createAction(
  '[Merchant: Other]: Update Merchant Attributes',
);

export const DayOffsetValueChanged = createAction(
  '[Merchant: Other]: Day Offset Value Changed',
  props<{ dayOffsetValue: string }>(),
);

export const StringTableChanged = createAction(
  '[Merchant: Other]: String Table Changed',
  props<{ text: string; index: number }>(),
);

export const ExistingAttributeDateChanged = createAction(
  '[Merchant: Other]: Existing Attribute Date Changed',
  props<{ attributeDateText: string; index: number }>(),
);

export const ExistingBoolAttributeChanged = createAction(
  '[Merchant: Other]: Existing Boolean Attribute Changed',
  props<{ index: number }>(),
);
